import { Avatar } from '@repo/ui-kit/components/core/Avatars';
import { H6 } from '@repo/ui-kit/components/core/Typography';

import { FlexRow } from 'styles/layouts';

type TeamSelectorRowProp = {
  image: string;
  name: string;
};

const TeamSelectorRow: React.FC<TeamSelectorRowProp> = ({
  image,
  name,
}: TeamSelectorRowProp) => (
  <FlexRow alignItems="center" gap="var(--spacing-8)">
    <FlexRow width="24px">
      <Avatar fallback={name} src={image} />
    </FlexRow>
    <FlexRow alignItems="center" height="24px">
      <H6 bold>{name}</H6>
    </FlexRow>
  </FlexRow>
);

export default TeamSelectorRow;
